import React from "react";
import { defineBlock, smartProps, useSmartProp, ChildrenBlock, useEditor, useInspectorControl } from "@smartfire/wordpress-react";
import { PanelBody, PanelRow, ToggleControl } from '@wordpress/components';
import style from "./block.module.scss";
import { InnerBlocks } from '@wordpress/block-editor';
import {ReactComponent as Square} from '../assets/square.svg';

function Inspector() {
    const [showBorder, setShowBorder] = useSmartProp('showBorder');

    return <> 
            <PanelBody title="Bordure jaune" initialOpen={true}>
                <PanelRow>
                    <ToggleControl
                        label={'Afficher la bordure'}
                        checked={showBorder}
                        onChange={() => setShowBorder(!showBorder)}
                    />
                </PanelRow>
            </PanelBody>
        </>
}

function Block({ showBorder }) {
    useInspectorControl(Inspector);

    const {isEditing} = useEditor();
    return <div className={style.block}>
            <div className={style.container}>
                { isEditing ?
                    <>
                        <div className={style.innerBlocks}>
                            <InnerBlocks allowedBlocks={["smartfire/encart-item"]} />
                        </div >
                    </> :
                    <ChildrenBlock  /> 
                }
                {
                    showBorder &&
                    <div className={style.corner}>
                        <Square />
                    </div>
                }
            </div>
        </div>
}

export default defineBlock({
    Block,
    smartProps: {
        image: smartProps.any.withDefault(""),
        text: smartProps.string.withDefault(""),
        showBorder: smartProps.bool.withDefault(true)
    }, 
    setup: {
        title: "Encart"
    }
});